import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';
import { disableScrolling, enableScrolling } from '../services/Viewport';

export default class NavMobile extends Component {

    constructor($element) {
        super($element);
        this.$solutions = this.$element.find('[data-ref-solutions]');
        this.$solutionsOpener = this.$element.find('[data-ref-solutions-opener]');
    }

    prepare() {
        enquire.register(queries.smallMax, {
            match: ::this.attachMobile,
            unmatch: ::this.detachMobile
        });
    }

    attachMobile() {
        $(document).on('nav:open', ::this.open);
        $(document).on('nav:close', ::this.close);
    }

    detachMobile() {

    }

    open() {
        this.$element.append('<a class="nav-main__close" data-trigger="nav:close"><span class="icon icon-cross"></span></a>');
        this.$element.show();
        disableScrolling();
    }

    close() {
        this.$element.find('.nav-main__close').remove();
        this.$element.hide();
        enableScrolling();
    }
}



// WEBPACK FOOTER //
// ./components/NavMobile.js